import { Tooltip, TooltipProps, tooltipClasses } from '@mui/material';
import { styled } from '@mui/material/styles';

const CustomTooltip = styled(
  ({ className, ...props }: TooltipProps & { className?: string }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  )
)(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#fff',
    color: '#2F86DD',
    border: '1px solid #2F86DD',
    fontSize: '14px',
    borderRadius: '6px',
    padding: '8px 12px',
    boxShadow: 'none',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: '#fff',
    '&::before': {
      border: '1px solid #2F86DD',
      backgroundColor: '#fff',
    },
  },
}));

export default CustomTooltip;
